import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Badge,
  TextField,
  Autocomplete,
  Button,
} from "@mui/material";
import {
  AccountCircle,
  MoreVert as MoreIcon,
  Notifications as NotificationsIcon,
  Email,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useAnalysis,
  useAuth,
  useColor,
  useCompany,
  useDealer,
  useDealerCompany,
  useSidebar,
  useUser,
  useFleetList,
  useTheme,
} from "../../common/hooks";
import { useTheme as useMuiTheme } from "@mui/material/styles";
import { useGlobalSearch } from "../../common/contexts";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import { layoutStyle } from "./style";
import {
  getCompanyId,
  typeConstant,
} from "../../common/constants/commonFunction";
import { localStorageItemNames } from "../../common/constants";
import { themeType } from "../../common/constants/theme-type";
import { DEALEAR_DEFAULT } from "../../common/constants/dealer-name";

const Header = () => {
  const classes = layoutStyle();
  const { isSidebarOpen, setIsSidebarOpen } = useSidebar();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const navigation = useNavigate();
  const history = useLocation();
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const { colorHeader } = useColor();
  const { onLogout } = useAuth();
  const {
    companyHeader,
    getCompanyApi,
    setCompanyNameHeader,
    company,
    getCompanyLogo,
    companyLogo,
    setDealerNameHeader,
    setCompanyLogo,
    companyNameHeader,
  } = useCompany();
  const { getDealerCompanyListApi, dealerCompanyData, setDealerCompanyData } =
    useDealerCompany();
  const {
    dealer,
    getDealerApi,
    dealerId,
    companyDealerId,
    loading,
    setDealerId,
    setCompanyDealerId,
  } = useDealer();
  const { user, getUser } = useUser();

  const [companyDefaultValue, setCompanyDefaultValue] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [headerCompany, setHeaderCompany] = useState([]);
  const userType = localStorage.getItem(localStorageItemNames.type);
  const typeId = parseInt(localStorage.getItem("typeId"));
  const [companiesOption, setCompaniesOption] = useState([]);
  const [dealerDefaultValue, setDealerDefaultValue] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [reportName, setReportName] = React.useState(false);
  const {
    analysisReport,
    setPopupOpen,
    setAnalysisCompanyChange,
    setAnalysisDealerChange,
    setAnalysisCompanyNameChange,
    setAnalysisDealerNameChange,
    analysisCompanyDefaultNameChange,
    analysisDealerDefaultNameChange,
    analysisDealerNameChange,
    getAnalysisResultApi,
    analysisResult,
  } = useAnalysis();

  const { setGlobalSearchResult } = useGlobalSearch();
  const { currentThemeType, changeTheme } = useTheme();
  const muiTheme = useMuiTheme();
  const { fleetList, getFleetListApi } = useFleetList();
  const [hasLoadedSearchData, setHasLoadedSearchData] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchFocus = () => {
    if (!hasLoadedSearchData) {
      if (companyNameHeader) {
        const companyId = getCompanyId(userType, companyNameHeader);
        console.log("dealerCompanyData", dealerCompanyData);
        if (companyId) {
          getAnalysisResultApi({
            filter: { companyId: companyId },
            limit: 10000,
            offset: 0,
          });
        }
      }
      setHasLoadedSearchData(true);
    }
  };

  const handleGlobalSearchSelect = (selected) => {
    if (!selected) return;
    if (selected.category === "Suggested 5-Year Plan & Cost Comparison Analysis Reports") {
      navigation(selected.path, { state: { data: selected.data } });
    } else {
      setGlobalSearchResult(selected);
      navigation(selected.path);
    }
  };

  const searchOptions = [
    ...(fleetList || []).map((f) => ({
      name: `Fleet #${f.fleetNo || ""}`,
      path: "/current-fleet-details",
      category: "Fleets",
      data: f,
    })),
    ...(analysisResult || []).map((r) => ({
      name: r.reportName || "",
      path: "/suggested-plan-cost-comparison-analysis-reports",
      category: "Suggested 5-Year Plan & Cost Comparison Analysis Reports",
      data: r,
    })),
  ];

  const filteredOptions = searchQuery.trim().length > 0 ? searchOptions : [];

  let url = window.location.pathname;

  useEffect(() => {
    if (url === "/suggested-plan-cost-comparison-analysis-reports") {
      setReportName(analysisReport?.reportName);
    } else {
      setReportName("");
    }
  }, [url, analysisReport]);

  useEffect(() => {
    getCompanyApi();
    getDealerApi();
    getUser();
  }, [userType]);

  useEffect(() => {
    if (userType === "admin" && selectedUser) {
      getDealerCompanyListApi({
        dealerId: DEALEAR_DEFAULT.dealerId,
        userId: selectedUser,
      });
    } else if (userType === "user") {
      getDealerCompanyListApi({
        dealerId: DEALEAR_DEFAULT.dealerId,
        userId: localStorage.getItem(localStorageItemNames.userID),
      });
    } else if (userType !== 'user' && userType !== 'admin') {
      onLogout();
    }
  }, [typeId, userType]);

  useEffect(() => {
    if (user?.length > 0) {
      const savedUserId = localStorage.getItem(localStorageItemNames.userID);
      const matchedUser = user.find((u) => u.id === parseInt(savedUserId));
      if (matchedUser) {
        setSelectedUser(matchedUser);
      } else {
        setSelectedUser(user[0]);
        localStorage.setItem(localStorageItemNames.userID, user[0].id);
      }
    }
  }, [user]);

  const handleUserChange = (event, value) => {
    setSelectedUser(value);
    if (value && value.id) {
      localStorage.setItem(localStorageItemNames.userID, value.id);
    } else {
      localStorage.removeItem(localStorageItemNames.userID);
    }
  };

  useEffect(() => {
    if (userType == typeConstant.dealer && companyDefaultValue?.id) {
      getCompanyLogo(companyDefaultValue.id);
    }
  }, [companyDefaultValue]);

  const handleDealerChange = (event, value) => {
    console.log("value", value);
    if (reportName) {
      setPopupOpen(true);
      if (value?.companies) {
        setCompaniesOption(value?.companies);
      }
      setAnalysisDealerChange(value);
      setAnalysisDealerNameChange(value);
      setDealerId(null);
      setCompanyDealerId(null);
    } else {
      setCompanyDefaultValue(null);
      setCompanyNameHeader(null);
      if (value?.companies) {
        setCompaniesOption(value?.companies);
      }
      setDealerDefaultValue(value);
      setDealerNameHeader(value);
      setDealerId(null);
      setCompanyDealerId(null);
    }
    if (value && value.id) {
      localStorage.setItem(localStorageItemNames.dealerId, value.id);
    } else {
      localStorage.removeItem(localStorageItemNames.dealerId);
      localStorage.removeItem(localStorageItemNames.companyId);
    }
  };

  useEffect(() => {
    if (companyDealerId && dealerId) {
      localStorage.setItem(localStorageItemNames.dealerId, dealerId);
      localStorage.setItem(localStorageItemNames.companyId, companyDealerId);
      let companyId;
      let dealerFilter = dealer?.filter((items) => items.id == dealerId);
      if (dealerFilter?.length > 0) {
        companyId = dealerFilter[0]?.companies?.filter(
          (items) => items.id == companyDealerId,
        );
      } else {
        companyId = company?.filter((items) => items.id == companyDealerId);
      }
      setDealerDefaultValue(dealerFilter[0]);
      if (companyId?.length > 0) {
        setCompanyDefaultValue(companyId[0]);
        setCompanyNameHeader(companyId[0]);
      }
      if (dealerFilter?.length > 0) {
        setDealerNameHeader(dealerFilter[0]);
        setCompaniesOption(dealerFilter[0]?.companies);
      }
    } else if (userType === "admin" && companyHeader) {
      if (selectedUser) {
        if (dealerCompanyData?.length > 0) {
          const mappedCompanies = dealerCompanyData.map((item) => ({
            ...item,
            id: item.companyId || item.id,
            companyName: item.companyName,
          }));
          setCompaniesOption(mappedCompanies);
          const hasMatchingCompany = mappedCompanies.some(
            (c) => c.id === companyDefaultValue?.id,
          );
          if (!hasMatchingCompany && mappedCompanies.length > 0) {
            setCompanyDefaultValue(mappedCompanies[0]);
            setCompanyNameHeader(mappedCompanies[0]);
            localStorage.setItem(
              localStorageItemNames.companyId,
              mappedCompanies[0].id,
            );
          } else if (mappedCompanies.length === 0) {
            setCompanyDefaultValue(null);
            setCompanyNameHeader(null);
            localStorage.removeItem(localStorageItemNames.companyId);
          }
        } else {
          setCompaniesOption([]);
          setCompanyDefaultValue(null);
          setCompanyNameHeader(null);
          localStorage.removeItem(localStorageItemNames.companyId);
        }
      } else if (dealer.length > 0) {
        const dealer1 = dealer.find((items) => items.id === 1) || dealer[0];
        setDealerDefaultValue(dealer1);
        setDealerNameHeader(dealer1);
        if (dealer1.companies?.length > 0) {
          setCompaniesOption(dealer1.companies);
          if (!companyDefaultValue) {
            setCompanyNameHeader(dealer1.companies[0]);
            setCompanyDefaultValue(dealer1.companies[0]);
          }
        } else {
          setCompaniesOption([]);
          setCompanyNameHeader(null);
        }
      }
    } else if (userType === "user" && dealerCompanyData) {
      if (dealerCompanyData?.length > 0) {
        const mappedCompanies = dealerCompanyData.map((item) => ({
          ...item,
          id: item.companyId || item.id,
          companyName: item.companyName,
        }));
        setCompaniesOption(mappedCompanies);
        const hasMatchingCompany = mappedCompanies.some(
          (c) => c.id === companyDefaultValue?.id,
        );
        if (!hasMatchingCompany && mappedCompanies.length > 0) {
          setCompanyDefaultValue(mappedCompanies[0]);
          setCompanyNameHeader(mappedCompanies[0]);
          localStorage.setItem(
            localStorageItemNames.companyId,
            mappedCompanies[0].id,
          );
        } else if (mappedCompanies.length === 0) {
          setCompanyDefaultValue(null);
          setCompanyNameHeader(null);
          localStorage.removeItem(localStorageItemNames.companyId);
        }
      } else {
        setCompanyDefaultValue(null);
        setCompanyNameHeader([]);
      }
    }
  }, [
    userType,
    companyHeader,
    dealerCompanyData,
    dealerId,
    companyDealerId,
    dealer,
    selectedUser,
  ]);

  useEffect(() => {
    if (userType === "admin" && selectedUser && selectedUser.id) {
      getDealerCompanyListApi({ userId: selectedUser.id });
    }
  }, [selectedUser, userType]);

  useEffect(() => {
    if (analysisCompanyDefaultNameChange) {
      setCompanyDefaultValue(analysisCompanyDefaultNameChange);
      setCompanyNameHeader(analysisCompanyDefaultNameChange);
    }
    if (analysisDealerDefaultNameChange) {
      setDealerDefaultValue(analysisDealerDefaultNameChange);
      setDealerNameHeader(analysisDealerDefaultNameChange);
      if (analysisDealerDefaultNameChange?.companies?.length > 0) {
        setCompanyDefaultValue(analysisCompanyDefaultNameChange);
        setCompanyNameHeader(analysisCompanyDefaultNameChange);
        setCompaniesOption(analysisDealerDefaultNameChange?.companies);
      } else {
        setCompanyDefaultValue(null);
        setCompanyNameHeader(null);
        setCompaniesOption([]);
      }
    }
  }, [analysisCompanyDefaultNameChange, analysisDealerDefaultNameChange]);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleProfile = () => {
    setAnchorEl(null);
    navigation("/profile");
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleLogout = async () => {
    setDealerId(null);
    setCompanyDealerId(null);
    setCompanyNameHeader(null);
    setDealerNameHeader(null);
    setCompanyLogo(null);
    await onLogout();
  };

  const handleCompanyChange = (e, value) => {
    if (reportName) {
      setPopupOpen(true);
      setAnalysisCompanyChange(value);
      setAnalysisCompanyNameChange(value);
    } else {
      setCompanyNameHeader(value);
      setCompanyDefaultValue(value);
    }
    if (value && value.id) {
      localStorage.setItem(localStorageItemNames.companyId, value.id);
    } else {
      localStorage.removeItem(localStorageItemNames.companyId);
    }
  };

  const menuId = "primary-search-account-menu";
  const profileMenuStyles = {
    paper: {
      background: muiTheme.palette.background.paper,
      border: `1px solid ${"var(--divider)"
        }`,
      borderRadius: "14px",
      boxShadow:
        muiTheme.palette.mode === "dark"
          ? "0 20px 60px rgba(0,0,0,0.45)"
          : "0 20px 60px rgba(2, 6, 23, 0.08)",
      minWidth: 160,
    },
  };

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      PaperProps={{ sx: profileMenuStyles.paper }}
    >
      <MenuItem
        onClick={handleProfile}
        sx={{
          color: muiTheme.palette.text.primary,
          fontSize: 14,
          fontWeight: 500,
          gap: 1.5,
          "&:hover": {
            background: muiTheme.palette.action.hover,
            color: muiTheme.palette.primary.main,
          },
        }}
      >
        👤 &nbsp; Profile
      </MenuItem>
      <MenuItem
        onClick={() => {
          changeTheme(
            currentThemeType === themeType.light
              ? themeType.dark
              : themeType.light,
          );
          handleMenuClose();
        }}
        sx={{
          color: muiTheme.palette.text.primary,
          fontSize: 14,
          fontWeight: 500,
          gap: 1.5,
          "&:hover": {
            background: muiTheme.palette.action.hover,
            color: muiTheme.palette.primary.main,
          },
        }}
      >
        {currentThemeType === themeType.light
          ? "🌙 Dark Mode"
          : "☀️ Light Mode"}
      </MenuItem>
      <MenuItem
        onClick={handleLogout}
        sx={{
          color: muiTheme.palette.text.primary,
          fontSize: 14,
          fontWeight: 500,
          gap: 1.5,
          "&:hover": { background: "rgba(239,68,68,.1)", color: "var(--state-danger)" },
        }}
      >
        🚪 &nbsp; Logout
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton size="large" aria-label="show 4 new mails">
          <Badge badgeContent={4} color="error">
            <Email />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={17} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls={menuId}
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          background: muiTheme.palette.mode === "dark" ? "rgba(7, 16, 31, 0.7)" : "rgba(255, 255, 255, 0.8)",
          borderBottom: "1px solid var(--divider)",
          backdropFilter: "blur(12px)",
          boxShadow: "none",
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            sx={{ mr: 2, color: muiTheme.palette.primary.main }}
          >
            <MenuIcon />
          </IconButton>

          {/* Brand Logo */}
          <Box
            sx={{
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              height: "60px",
              mr: 2,
              flexShrink: 0,
            }}
          >
            <img
              src="/logo.png"
              alt="Logo"
              style={{ height: "60px", width: "auto", objectFit: "contain" }}
            />
          </Box>

          {/* Global Search Bar */}
          <Box sx={{ mr: 2, flexShrink: 0 }}>
            <Autocomplete
              id="global-search-autocomplete"
              freeSolo
              disableClearable
              options={filteredOptions}
              inputValue={searchQuery}
              onInputChange={(event, newInputValue) => {
                setSearchQuery(newInputValue);
              }}
              groupBy={(option) => option.category}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.name || ""
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  handleGlobalSearchSelect(newValue);
                  setSearchQuery("");
                }
              }}
              onFocus={handleSearchFocus}
              sx={{
                width: { xs: "180px", sm: "240px", md: "320px" },
                transition: "all 0.3s ease",
                "& .MuiOutlinedInput-root": {
                  color: muiTheme.palette.text.primary,
                  padding: "2px 9px",
                  borderRadius: "24px",
                  backgroundColor:
                    muiTheme.palette.mode === "dark"
                      ? "rgba(255, 255, 255, 0.06)"
                      : "var(--bg-page)",
                  border: `1px solid var(--divider)`,
                  "&:hover": {
                    backgroundColor:
                      muiTheme.palette.mode === "dark"
                        ? "rgba(255,255,255,0.08)"
                        : "var(--surface)",
                    borderColor: muiTheme.palette.primary.main,
                  },
                  "&.Mui-focused": {
                    backgroundColor:
                      muiTheme.palette.mode === "dark"
                        ? "rgba(255,255,255,0.08)"
                        : "var(--surface)",
                    borderColor: muiTheme.palette.primary.main,
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "& .MuiSvgIcon-root": {
                  color: muiTheme.palette.text.secondary,
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search globally..."
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon
                          sx={{
                            fontSize: 18,
                            color: muiTheme.palette.text.secondary,
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Box>

          <Box className={classes.titleHeader}>
            {reportName !== "" && reportName !== null && (
              <Box className={classes.reportNameHeader}>
                <span className={classes.dealerNameTitle}>
                  Report Name : {reportName}
                </span>
              </Box>
            )}
            <Box sx={{ flexGrow: 1 }} />{" "}
            {history.pathname !== "/reports" &&
              userType == typeConstant.dealer &&
              companyLogo?.companyImage && (
                <Box className={classes.dealerLogo}></Box>
              )}
          </Box>
          <Box
            sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}
          >
            {localStorage.getItem(localStorageItemNames.type) === "admin" && (
              <Autocomplete
                disablePortal
                id="user-select-dropdown"
                size="small"
                variant="outlined"
                sx={{
                  width: "150px",
                  marginRight: "10px",
                  ".MuiSvgIcon-root, .MuiInputBase-root ": {
                    color: muiTheme.palette.text.primary,
                  },
                  ".MuiInputBase-root": {
                    fontSize: "12px",
                    "&:before": {
                      borderBottom: `1px solid var(--divider)`,
                    },
                    "&:after": {
                      borderBottom: `2px solid ${muiTheme.palette.primary.main}`,
                    },
                  },
                }}
                loading={loading}
                loadingText="Fetching..."
                options={user || []}
                getOptionLabel={(option) =>
                  option.name || option.username || ""
                }
                value={selectedUser}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="User"
                    sx={{
                      ".MuiFormLabel-root": {
                        color: `${muiTheme.palette.text.primary} !important`,
                        fontSize: 12,
                      },
                    }}
                  />
                )}
                onChange={handleUserChange}
              />
            )}
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              size="small"
              variant="outlined"
              sx={{
                width: "150px",
                marginRight: "10px",
                ".MuiSvgIcon-root, .MuiInputBase-root ": {
                  color: muiTheme.palette.text.primary,
                },
                ".MuiInputBase-root": {
                  fontSize: "12px",
                  "&:before": {
                    borderBottom: `1px solid var(--divider)`,
                  },
                  "&:after": {
                    borderBottom: `2px solid ${muiTheme.palette.primary.main}`,
                  },
                },
              }}
              loading={loading}
              loadingText="Fetching..."
              options={companiesOption}
              getOptionLabel={(option) => option.companyName}
              value={companyDefaultValue}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  label="Company"
                  sx={{
                    ".MuiFormLabel-root": {
                      color: `${muiTheme.palette.text.primary} !important`,
                      fontSize: 12,
                    },
                  }}
                />
              )}
              onChange={handleCompanyChange}
            />

            <Box
              sx={{
                textTransform: "capitalize",
                fontSize: 13,
                fontWeight: 600,
                color: muiTheme.palette.text.primary,
                mr: 2,
                width: 100
              }}
            >
              {localStorage.getItem(localStorageItemNames.name)}
            </Box>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              sx={{
                color: muiTheme.palette.text.secondary,
                "&:hover": { color: muiTheme.palette.primary.main },
              }}
            >
              <AccountCircle />
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </>
  );
};

export default Header;
